<template>
  <v-container class="mt-7 mb-7" fluid>
    <v-row align="center" justify="center">
      <h1 style="font-size: 25px;" v-if="endDate < new Date()">{{ $t('finished') }}</h1>
      <div v-else-if="startDate > new Date()">
        <h2 class="text-center">{{ $t('willStart') }}</h2>
        <Counter :end-time="startDate" :text-color="'#111111'" :title-color="'#111111'" class="justify-center"/>
      </div>
      <div v-else>
        <h2 class="text-center">{{ $t('willEnd') }}</h2>
        <Counter :end-time="endDate" :text-color="'#111111'" :title-color="'#111111'" class="justify-center"/>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import Counter from "@/components/Counter";

export default {
  name: "TournamentTimer",
  components: {Counter},
  props: {
    startDate: Date,
    endDate: Date,
  }
}
</script>

<i18n>
{
  "en": {
    "finished": "Tournament Finished! 🎉",
    "willStart": "Tournament will start in",
    "willEnd": "Tournament will end in"
  },
  "es": {
    "finished": "¡Torneo Finalizado! 🎉",
    "willStart": "El torneo iniciará en",
    "willEnd": "El torneo finalizará en"
  }
}
</i18n>

<style scoped>

</style>
